import { useEffect, useState } from "react"
import "./App.css"
import NotificationProvider from "./notifications"
import RoutesProvider from "./router"
import { CookieConsentDialog } from "./components/cookie-consent-dialog"
import { getCookieConsent } from "./utils/cookies"
import { LocaleSync } from "./components/locale-sync"

function App() {
  const [showCookieDialog, setShowCookieDialog] = useState(false)

  useEffect(() => {
    // Check if user has already given consent
    const hasConsented = getCookieConsent()
    if (!hasConsented) {
      // Small delay to ensure the app is fully loaded
      const timer = setTimeout(() => {
        setShowCookieDialog(true)
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [])

  return (
    <NotificationProvider>
      <LocaleSync />
      <RoutesProvider />
      <CookieConsentDialog
        open={showCookieDialog}
        onOpenChange={setShowCookieDialog}
      />
    </NotificationProvider>
  )
}

export default App
